<app-modal
  [isVisible]="isVisible()"
  [config]="modalConfig()"
  [primaryButtonDisabled]="primaryButtonDisabled()"
  [primaryButtonLoading]="primaryButtonLoading()"
  (confirmed)="onModalConfirmed()"
  (cancelled)="onModalCancelled()"
  (secondary)="onModalCancelled()"
  (closed)="onModalClosed()"
>
  <!-- Header Icon -->
  <div class="modal-header-icon">
    <app-icon iconKey="customers" [showLabel]="false"></app-icon>
  </div>

  <!-- Description -->
  <p class="modal-description">{{ 'modals.create_customer_org.description' | transloco }}</p>

  <!-- Error Message -->
  @if (error()) {
    <div class="modal-error">
      <span>{{ error() }}</span>
      <button type="button" (click)="clearError()">×</button>
    </div>
  }

  <!-- Form Fields -->
  <div class="field">
    <label for="customerOrgName">{{ 'modals.create_customer_org.name_label' | transloco }}</label>
    <input
      id="customerOrgName"
      type="text"
      [placeholder]="'modals.create_customer_org.name_placeholder' | transloco"
      [(ngModel)]="organizationName"
      [disabled]="isLoading()"
      (input)="clearError()"
    />
    <small>{{ 'modals.create_customer_org.name_hint' | transloco }}</small>
  </div>

  <div class="field">
    <label for="customerAdminEmail">{{
      'modals.create_customer_org.admin_email_label' | transloco
    }}</label>
    <div class="input-wrapper">
      <input
        id="customerAdminEmail"
        type="email"
        placeholder="admin@customer.com"
        [(ngModel)]="adminEmail"
        [disabled]="isLoading()"
        (input)="clearError()"
      />
      <app-icon iconKey="email" [showLabel]="false" class="input-trailing-icon"></app-icon>
    </div>
    <small>{{ 'modals.create_customer_org.admin_email_hint' | transloco }}</small>
  </div>
</app-modal>
